import React from 'react';
import { ArrowUpRight, Factory, Fuel, FlaskConical, Sun, Zap, Atom, Leaf } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Factory, Fuel, FlaskConical, Sun, Zap, Atom };

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-emerald-50/40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-white text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> Our Services
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold text-[#0b1a1a] leading-tight">
            Our Company <span className="text-emerald-600">Solutions</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            From eco-friendly fuel production to complete project planning, installation, execution and continuous maintenance — we deliver efficient, cost-effective, and future-ready solutions.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Leaf;
            return (
              <a key={s.id} href={`#${s.id}`}
                 className="group relative bg-white rounded-3xl p-7 border border-slate-100 hover:border-emerald-200 hover:-translate-y-1 transition-all duration-300 overflow-hidden shadow-sm hover:shadow-xl hover:shadow-emerald-100">
                <div className="absolute -bottom-16 -right-16 w-48 h-48 rounded-full bg-emerald-50 group-hover:bg-emerald-100 transition-colors" />

                <div className="relative">
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 grid place-items-center shadow-md shadow-emerald-200">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="mt-5 text-xl font-extrabold text-[#0b1a1a]">{s.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed text-sm">{s.desc}</p>

                  <div className="mt-6 inline-flex items-center gap-2 text-emerald-600 font-semibold text-sm group-hover:gap-3 transition-all">
                    Learn More <ArrowUpRight className="w-4 h-4" />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
